import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { BookingGetProQuery, BookingGetProQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const BOOKING_GET_PRO = graphql(`
  query BookingGetPro($where: ProfessionalWhereInput!, $language: String!) {
    searchProfessionals(take: 1, where: $where) {
      professionals {
        id
        type
        acceptedAnimals
        onlineBookingEnabled
        imgs(take: 1) {
          id
          small
        }

        address {
          id
          zip
          city
        }

        translations {
          id
          language
          title
          preBookingWarning
        }
        workers {
          id
          fullName
        }

        services(language: $language) {
          id

          service {
            id
            translations {
              id
              language
              title
            }
          }

          workerServices {
            id
            bookingDuration
            multiAnimalsBookingEnabled
            multiAnimalsDuration
            price
            priceType
            priceFrom
            priceTo
            translations {
              id
              language
              preBookingWarning
            }
          }
        }
      }
    }
  }
`);

export const useGetPro = (url?: string) => {
  const { language } = useRouter();

  const variables = useMemo((): BookingGetProQueryVariables => {
    return {
      where: {
        OR: [{ translations: { some: { url: { equals: url } } } }, { proMongoId: { equals: url } }],
      },
      language,
    };
  }, [url, language]);

  const { data, error, loading } = useQuery<BookingGetProQuery, BookingGetProQueryVariables>(
    BOOKING_GET_PRO,
    { variables, skip: url == null },
  );

  return {
    pro: data?.searchProfessionals.professionals?.[0],
    proError: error,
    proLoading: loading,
  };
};
